import EKycConsent from "./ekyc_consent.management.page";

export default EKycConsent;
